'use strict';

module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/dibs-currency-helpers/currencies.js
// module id = 2049
// module chunks = 62